import React from 'react';
import { Frown, Smile, ArrowRight } from 'lucide-react';
export function BenefitsSection() {
  return <section className="bg-[#0A1628] py-20 px-4 relative overflow-hidden" data-id="element-33">
      {/* Subtle gold accents */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#D4AF37] opacity-5 rounded-full blur-3xl" data-id="element-34"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#D4AF37] opacity-5 rounded-full blur-3xl" data-id="element-35"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-36">
        <div className="text-center mb-16" data-id="element-37">
          <h2 className="text-3xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-38">
            Tu transformación con el <br className="hidden md:block" data-id="element-39" />
            <span className="text-[#D4AF37]" data-id="element-40">Método Detailing Pro</span>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12" data-id="element-41">
          {/* Before */}
          <div className="bg-red-950/60 border-2 border-red-800/50 rounded-3xl p-8 md:p-12 w-full md:w-1/2 shadow-lg relative" data-id="element-42">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-red-600 text-white font-black px-6 py-2 rounded-full uppercase tracking-wider" data-id="element-43">
              ANTES
            </div>
            <div className="flex justify-center mb-6 mt-4" data-id="element-44">
              <Frown className="w-16 h-16 text-red-400" data-id="element-45" />
            </div>
            <ul className="space-y-4" data-id="element-46">
              <li className="flex items-center gap-3 text-red-200 font-medium text-lg" data-id="element-47">
                <span className="text-red-500 font-bold text-xl" data-id="element-48">✕</span>{' '}
                Confusión sobre qué productos usar
              </li>
              <li className="flex items-center gap-3 text-red-200 font-medium text-lg" data-id="element-49">
                <span className="text-red-500 font-bold text-xl" data-id="element-50">✕</span>{' '}
                Errores costosos al pulir
              </li>
              <li className="flex items-center gap-3 text-red-200 font-medium text-lg" data-id="element-51">
                <span className="text-red-500 font-bold text-xl" data-id="element-52">✕</span> Miedo
                constante a arruinar la pintura
              </li>
              <li className="flex items-center gap-3 text-red-200 font-medium text-lg" data-id="element-53">
                <span className="text-red-500 font-bold text-xl" data-id="element-54">✕</span>{' '}
                Trabajar gratis o cobrar muy poco
              </li>
            </ul>
          </div>

          {/* Arrow (Desktop) */}
          <div className="hidden md:flex items-center justify-center" data-id="element-55">
            <ArrowRight className="w-12 h-12 text-[#D4AF37]" data-id="element-56" />
          </div>

          {/* Arrow (Mobile) */}
          <div className="md:hidden flex items-center justify-center transform rotate-90 my-4" data-id="element-57">
            <ArrowRight className="w-10 h-10 text-[#D4AF37]" data-id="element-58" />
          </div>

          {/* After */}
          <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-[#D4AF37] rounded-3xl p-8 md:p-12 w-full md:w-1/2 shadow-2xl relative transform md:scale-105" data-id="element-59">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-[#D4AF37] text-black font-black px-8 py-2 rounded-full uppercase tracking-wider shadow-lg" data-id="element-60">
              DESPUÉS
            </div>
            <div className="flex justify-center mb-6 mt-4" data-id="element-61">
              <Smile className="w-16 h-16 text-[#D4AF37]" data-id="element-62" />
            </div>
            <ul className="space-y-4" data-id="element-63">
              <li className="flex items-center gap-3 text-white font-medium text-lg" data-id="element-64">
                <span className="text-[#D4AF37] font-bold text-xl" data-id="element-65">✓</span>{' '}
                Confianza total en cada proceso
              </li>
              <li className="flex items-center gap-3 text-white font-medium text-lg" data-id="element-66">
                <span className="text-[#D4AF37] font-bold text-xl" data-id="element-67">✓</span>{' '}
                Conocimiento técnico profesional
              </li>
              <li className="flex items-center gap-3 text-white font-medium text-lg" data-id="element-68">
                <span className="text-[#D4AF37] font-bold text-xl" data-id="element-69">✓</span>{' '}
                Resultados espejo garantizados
              </li>
              <li className="flex items-center gap-3 text-white font-medium text-lg" data-id="element-70">
                <span className="text-[#D4AF37] font-bold text-xl" data-id="element-71">✓</span>{' '}
                Generar ingresos reales con detailing
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}